
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    if(window.flitsObjects.allCssJs.cartJs){
      Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
    }
    
  }
  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    if(window.flitsObjects.allCssJs.wishlistJs){
      Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
    }
  }
  Flits(document).on('Flits:StoreCreditCart:Loaded', function(event){
    var data = event.detail.settings;
    data.checkoutButtonSelectors = ["input[name='checkout']", "button[name='checkout']", "[href$='checkout']", "button[name='icartCheckout']", "#dropdown-cart button.btn-checkout"];
 });
  Flits(document).on('Flits:wishlistButton:Loaded', function(event){
    setTimeout(function(){
      let collectionBtn = Flits(".flits-wishlist-colection");
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
        Flits(collectionBtn).show(),
        Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
    }, 3000);
  });
  Flits(document).on('Flits:WishlistAutomaticCode:Loaded', function(event){

    var data = event.detail;
    
    var el = data.el;
    var parent = data.parent; // parent
    var cloneNode = data.cloneNode; // cloned social login div
    //parent.prepend(cloneNode);
    if(Flits(parent).find('form[action="/cart/add"][data-flits="wishlist-btn-added"] .groups-btn .groups-btn-tree').length){
      Flits(parent).find('form[action="/cart/add"][data-flits="wishlist-btn-added"] .groups-btn .groups-btn-tree').append(cloneNode)
    }
  });
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=quickview'
    (-1 !== url.indexOf("?view=quickview")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits(".ajax-quickview").find(".filts-wishlist-product-style .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).parent().removeAttr('id');
        Flits(single_grid_item).parents('.product-shop').attr('data-flits', 'wishlist-btn-parent')
        //Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');

        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive");
          Flits(single_grid_item).addClass("flits-wls-active");
          Flits(single_grid_item).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        }
      });
    }, 1000);
  });

  $( document ).ajaxComplete(function( event, xhr, settings ) {
    if(Flits.request.page_type == 'index' || Flits.request.page_type == 'collection'){
      setTimeout(function(){
        let collectionBtn = Flits(".flits-wishlist-colection");
        parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
          Flits(collectionBtn).show(),
          Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
      }, 5000);
      setTimeout(function(){
        Flits('.flits-wishlist-colection').each(function(index,ele){
        	let wishProdHandle = Flits(ele).find('.flits-wls-button').attr('data-flits-product-handle');
          if(Flits.isProductAddedInWishlist(wishProdHandle)){ 
            Flits(ele).find('.flits-wls-button').removeClass("flits-wls-inactive")
            Flits(ele).find('.flits-wls-button').addClass("flits-wls-active")
            Flits(ele).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'))
          }
        });
      },7000);
    }
  });
}(Flits));
